
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transfer/flow-of-funds",
      function () {
        return require("private-next-pages/docs/transfer/flow-of-funds.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transfer/flow-of-funds"])
      });
    }
  